import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=1c086f4a&scoped=true"
import script from "./Savings.vue?vue&type=script&lang=js"
export * from "./Savings.vue?vue&type=script&lang=js"
import style0 from "./Savings.vue?vue&type=style&index=0&id=1c086f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c086f4a",
  null
  
)

export default component.exports